module.exports = __webpack_public_path__ + "media/images/beauty/pascaline@2x-f9a6eb54de550f4cd99f6c4c6e0866c6.jpg";